import { DOUBLE_TAP_INTERVAL_MS, DOUBLE_TAP_MAX_DISTANCE_PX } from "../constants";

/**
 * Double click and double tap in one place, the same for mouse and touch.
 */
export const createTapDetector = () => {
  let lastTap = null;

  return {
    /**
     * @param {{ x: number, y: number, time: number, region: string }} tap
     * @returns {boolean} true when the tap completes a double tap in the same region
     */
    isDoubleTap: (tap) => {
      const isDouble =
        Boolean(lastTap) &&
        lastTap.region === tap.region &&
        tap.time - lastTap.time <= DOUBLE_TAP_INTERVAL_MS &&
        Math.hypot(tap.x - lastTap.x, tap.y - lastTap.y) <= DOUBLE_TAP_MAX_DISTANCE_PX;

      lastTap = isDouble ? null : tap;

      return isDouble;
    },
  };
};
